import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <>
        <Helmet>
            <title>Página no encontrada - Conecta</title>
        </Helmet>
        <div className="bg-dark-primary w-100" style={{minHeight: '100vh'}}>
            <div className="auth d-flex justify-content-center align-items-center text-center" style={{flexDirection: 'column'}}>
                <h1 className="text-light font-weight-700" style={{fontSize: '60px'}}>404</h1>
                <h2 className="text-light font-weight-600">No hemos encontrado esta página</h2>
                <span className="text-light font-weight-400 mt-2">La página que buscas no existe, disculpe las molestias ocasionadas.</span>
                <Link to="/admin/dashboard" className="btn btn-secondary btn-rounded mt-4" style={{width: '200px'}}>Ir al inicio</Link>
            </div>
        </div>
        </>
    )
}
